import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-0.5,-2.5h1.5v0.5h-1.5zM-1,-2h2.5v2h-2.5zM4.5,-1h0.5v0.5h-0.5zM-5.5,-0.5h1v0.5h-1zM4.5,-0.5h1v0.5h-1zM-5.5,0h0.5v0.5h-0.5zM-1,0h3.5v0.5h-3.5zM4,0h0.5v0.5h-0.5zM-3.5,0.5h7v0.5h-7zM-3,1h5.5v0.5h-5.5zM-2,1.5h3v0.5h-3zM-0.5,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-4.5,-9.5h2.5v0.5h-2.5zM-4.5,-9h1v0.5h-1zM-3,-9h0.5v0.5h-0.5zM1.5,-9h1v0.5h-1zM3,-9h0.5v0.5h-0.5zM-4.5,-8.5h2.5v0.5h-2.5zM1,-8.5h2.5v0.5h-2.5zM-4.5,-8h0.5v0.5h-0.5zM-3,-8h0.5v0.5h-0.5zM1,-8h1v0.5h-1zM2.5,-8h0.5v0.5h-0.5zM3.5,-8h1v0.5h-1zM-4.5,-7.5h1.5v1.5h-1.5zM-2.5,-7.5h0.5v1h-0.5zM1,-7.5h2.5v0.5h-2.5zM4,-7.5h0.5v0.5h-0.5zM1,-7h1v1h-1zM3,-6.5h0.5v0.5h-0.5zM-4.5,-6h1v1h-1zM-3,-6h0.5v0.5h-0.5zM1,-6h1.5v1h-1.5zM-3,-5.5h1v0.5h-1zM-4.5,-5h2.5v4.5h-2.5zM1,-5h2v0.5h-2zM1,-4.5h2.5v2.5h-2.5zM1.5,-2h2v1h-2zM3,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4,-10h2v0.5h-2zM-2,-9.5h0.5v0.5h-0.5zM3.5,-9h0.5v0.5h-0.5zM3.5,-8.5h1v0.5h-1zM-2,-7.5h0.5v0.5h-0.5zM3.5,-7.5h0.5v0.5h-0.5zM-2,-7h1v1h-1zM4,-7h0.5v0.5h-0.5zM3.5,-6.5h1v1.5h-1zM-2.5,-6h1.5v0.5h-1.5zM-2,-5.5h1v5.5h-1zM3,-5h1.5v0.5h-1.5zM3.5,-4.5h1v4h-1zM-2,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'sail',
      d: 'M-3.5,-8h0.5v0.5h-0.5zM-2.5,-8h0.5v0.5h-0.5zM-3,-7h0.5v1h-0.5zM2,-7h0.5v0.5h-0.5zM3,-7h0.5v0.5h-0.5zM2.5,-6h0.5v1h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M2,-10h1.5v0.5h-1.5zM1.5,-9.5h2.5v0.5h-2.5zM-3.5,-9h0.5v0.5h-0.5zM-2.5,-9h1v0.5h-1zM2.5,-9h0.5v0.5h-0.5zM-2,-8.5h0.5v1h-0.5zM-4,-8h0.5v0.5h-0.5zM2,-8h0.5v0.5h-0.5zM3,-8h0.5v0.5h-0.5zM-3,-7.5h0.5v0.5h-0.5zM2.5,-7h0.5v0.5h-0.5zM3.5,-7h0.5v0.5h-0.5zM-2.5,-6.5h0.5v0.5h-0.5zM2,-6.5h1v0.5h-1zM-3.5,-6h0.5v1h-0.5zM3,-6h0.5v1h-0.5zM1.5,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5zM-4.5,-0.5h0.5v0.5h-0.5zM4,-0.5h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'anvil',
      d: 'M-4,-12h2v1h-2zM-5,-11h4.5v1h-4.5zM-5,-10h1v0.5h-1zM-2,-10h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M2,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM1.5,-0.5h2.5v0.5h-2.5zM-5,0h2.5v0.5h-2.5zM2.5,0h1.5v0.5h-1.5zM-4.5,0.5h1v0.5h-1z',
    },
  ],
  pixels: 373,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-0.5,-2.5h1v0.5h-1zM-1,-2h1.5v1.5h-1.5zM4,-1h1v0.5h-1zM-5.5,-0.5h1v0.5h-1zM-1,-0.5h2.5v0.5h-2.5zM4,-0.5h1.5v0.5h-1.5zM-5.5,0h0.5v0.5h-0.5zM-1,0h3.5v0.5h-3.5zM4,0h0.5v0.5h-0.5zM-3.5,0.5h7v0.5h-7zM-3,1h5.5v0.5h-5.5zM-2,1.5h3v0.5h-3zM-0.5,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-4.5,-11h2.5v0.5h-2.5zM-4.5,-10.5h1v0.5h-1zM-3,-10.5h0.5v0.5h-0.5zM3,-10.5h0.5v0.5h-0.5zM-4.5,-10h2.5v0.5h-2.5zM0.5,-10h0.5v0.5h-0.5zM-4.5,-9.5h0.5v0.5h-0.5zM-3,-9.5h0.5v0.5h-0.5zM0.5,-9.5h2.5v1h-2.5zM-4.5,-9h1.5v1.5h-1.5zM-2.5,-9h0.5v1h-0.5zM0.5,-8.5h0.5v0.5h-0.5zM1.5,-8.5h2v0.5h-2zM0.5,-8h1v0.5h-1zM2,-8h0.5v1h-0.5zM-4.5,-7.5h1v1h-1zM-3,-7.5h0.5v0.5h-0.5zM0.5,-7.5h0.5v0.5h-0.5zM-3,-7h1v0.5h-1zM0.5,-7h1v2h-1zM2.5,-7h0.5v1h-0.5zM-4.5,-6.5h2.5v6h-2.5zM0.5,-5h1.5v0.5h-1.5zM2.5,-5h0.5v0.5h-0.5zM0.5,-4.5h2.5v3.5h-2.5zM1,-1h0.5v0.5h-0.5zM-3,-0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-4,-11.5h2v0.5h-2zM-2,-11h0.5v0.5h-0.5zM3,-9.5h0.5v1h-0.5zM-2,-9h0.5v1h-0.5zM-2,-8h1v0.5h-1zM3,-8h0.5v2h-0.5zM-2.5,-7.5h1.5v0.5h-1.5zM-2,-7h1v7h-1zM2.5,-6h1v1h-1zM3,-5h1v4.5h-1zM-2,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'sail',
      d: 'M-3.5,-9.5h0.5v0.5h-0.5zM-2.5,-9.5h0.5v0.5h-0.5zM-3,-8.5h0.5v1h-0.5zM2,-6.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-3.5,-10.5h0.5v0.5h-0.5zM-2.5,-10.5h1v0.5h-1zM1,-10.5h2v0.5h-2zM-2,-10h0.5v1h-0.5zM1,-10h2.5v0.5h-2.5zM-4,-9.5h0.5v0.5h-0.5zM-3,-9h0.5v0.5h-0.5zM1,-8.5h0.5v0.5h-0.5zM-2.5,-8h0.5v0.5h-0.5zM1.5,-8h0.5v0.5h-0.5zM2.5,-8h0.5v1h-0.5zM-3.5,-7.5h0.5v1h-0.5zM1,-7.5h1v0.5h-1zM1.5,-7h1v0.5h-1zM1.5,-6.5h0.5v0.5h-0.5zM1.5,-6h1v1h-1zM2,-5h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5zM-4.5,-0.5h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'anvil',
      d: 'M-4,-13.5h2v1h-2zM-5,-12.5h4.5v1h-4.5zM-5,-11.5h1v0.5h-1zM-2,-11.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M2,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM1.5,-0.5h2.5v0.5h-2.5zM-5,0h2.5v0.5h-2.5zM2.5,0h1.5v0.5h-1.5zM-4.5,0.5h1v0.5h-1z',
    },
  ],
  pixels: 393,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-0.5,-2.5h1.5v0.5h-1.5zM-1,-2h3v1.5h-3zM-5.5,-0.5h1v0.5h-1zM-1,-0.5h2.5v0.5h-2.5zM5,-0.5h0.5v0.5h-0.5zM-5.5,0h0.5v0.5h-0.5zM-1,0h3.5v0.5h-3.5zM4,0h0.5v0.5h-0.5zM-3.5,0.5h7v0.5h-7zM-3,1h5.5v0.5h-5.5zM-2,1.5h3v0.5h-3zM-0.5,2h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M2,-11h2v1h-2zM2,-10h3v0.5h-3zM-4.5,-9.5h0.5v0.5h-0.5zM-2,-9.5h0.5v0.5h-0.5zM2,-9.5h1v0.5h-1zM3.5,-9.5h0.5v0.5h-0.5zM-4.5,-9h2.5v1h-2.5zM2,-9h0.5v0.5h-0.5zM1.5,-8.5h1.5v1.5h-1.5zM3.5,-8.5h0.5v0.5h-0.5zM-4.5,-8h3v0.5h-3zM-4.5,-7.5h1v1h-1zM-3,-7.5h0.5v0.5h-0.5zM1.5,-7h1v0.5h-1zM3,-7h1v0.5h-1zM-4.5,-6.5h1.5v1.5h-1.5zM-2.5,-6.5h0.5v0.5h-0.5zM1.5,-6.5h2.5v3.5h-2.5zM-4.5,-5h1v0.5h-1zM-3,-5h0.5v0.5h-0.5zM-4.5,-4.5h2.5v4h-2.5zM1.5,-3h1v1h-1zM3,-3h1v1.5h-1zM2,-2h0.5v0.5h-0.5zM2,-1.5h2v0.5h-2zM5,-1.5h0.5v0.5h-0.5zM3,-1h1v0.5h-1zM-3,-0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M4,-11h1v1h-1zM4.5,-9.5h0.5v1h-0.5zM-2,-9h0.5v1h-0.5zM4,-8.5h1v7.5h-1zM2.5,-7h0.5v0.5h-0.5zM-2,-6.5h1v1h-1zM-2.5,-5.5h1.5v1h-1.5zM-2,-4.5h1v4.5h-1zM4,-1h1.5v0.5h-1.5zM-2,0h0.5v0.5h-0.5z',
    },
    { paint: 'sail', d: 'M3,-8h0.5v0.5h-0.5zM-3,-6.5h0.5v1h-0.5z' },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-4,-10h2.5v0.5h-2.5zM-4,-9.5h2v0.5h-2zM3,-9.5h0.5v0.5h-0.5zM4,-9.5h0.5v0.5h-0.5zM2.5,-9h2v0.5h-2zM3,-8.5h0.5v0.5h-0.5zM3.5,-8h0.5v0.5h-0.5zM-3.5,-7.5h0.5v0.5h-0.5zM-2.5,-7.5h1v0.5h-1zM3,-7.5h1v0.5h-1zM-3.5,-7h2v0.5h-2zM-2.5,-6h0.5v0.5h-0.5zM-3,-5.5h0.5v0.5h-0.5zM-3.5,-5h0.5v0.5h-0.5zM2.5,-3h0.5v1.5h-0.5zM2.5,-1h0.5v0.5h-0.5zM-4.5,-0.5h0.5v0.5h-0.5zM4,-0.5h1v0.5h-1zM-2.5,0h0.5v0.5h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'anvil',
      d: 'M2.5,-13.5h0.5v0.5h-0.5zM2.5,-13h2v0.5h-2zM2,-12.5h2.5v0.5h-2.5zM1,-12h4.5v1h-4.5zM1,-11h1v0.5h-1zM5,-11h0.5v0.5h-0.5z',
    },
    {
      paint: 'rock',
      d: 'M2,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM1.5,-0.5h2.5v0.5h-2.5zM-5,0h2.5v0.5h-2.5zM2.5,0h1.5v0.5h-1.5zM-4.5,0.5h1v0.5h-1z',
    },
  ],
  pixels: 394,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
